// Lot 716 — démarrage instantané (garde-fou « instant_boot ») : avec une session connue sur l'appareil (jeton + /auth/me
// mémorisé + réglages mémorisés), l'app s'affiche tout de suite — fil de la dernière visite compris — pendant que
// /config/public et /auth/me se rechargent en arrière-plan. Session invalide (401) → l'écran de connexion reprend la main.
import { guardOn } from "@/lib/guards";

// Pur (testé) : peut-on rendre l'app avant la réponse du serveur ?
export const canBootInstantly = ({ token, cachedUser, config, guard = guardOn("instant_boot") }) =>
  !!(guard && token && cachedUser?.id && config?.settings && Object.keys(config.settings).length > 0);

// Pur (testé) : amorce du fil au montage de Home quand aucun instantané n'existe. `cached` = readCachedFeed(uid).
// Hors ligne / reconnexion : comme avant (dernier fil lu, sans reprise de position). Démarrage instantané : même
// amorce, marquée `bootSeed` → la reprise de position (lot 682) et le rafraîchissement silencieux restent possibles.
export const seedFeedFromCache = ({ uid, cached, offline, instant = guardOn("instant_boot"), now = Date.now() }) => {
  if (!uid || !cached || !(offline || instant)) return null;
  return { uid, posts: cached.posts, hasMore: false, key: cached.key, filter: cached.filter, myLangOnly: cached.myLangOnly, fromCache: true, bootSeed: !offline, at: now };
};

// Pur (testé) : rangée de stories mémorisée → seules les stories encore valables (expires_at futur, sinon < 24 h) ;
// les groupes vidés disparaissent. Évite d'afficher une story expirée pendant la seconde où le serveur répond.
const DAY_MS = 24 * 3600 * 1000;
export const freshStoryGroups = (groups, now = Date.now()) => (groups || []).map((g) => {
  const stories = (g?.stories || []).filter((s) => {
    const exp = s?.expires_at ? Date.parse(s.expires_at) : NaN;
    if (!Number.isNaN(exp)) return exp > now;
    const created = s?.created_at ? Date.parse(s.created_at) : NaN;
    return Number.isNaN(created) ? true : now - created < DAY_MS;
  });
  return stories.length ? { ...g, stories } : null;
}).filter(Boolean);
